export class ChangeSubscriptionResponseDTO{
    currentSubscriptionId!: string;
    newSubscriptionId!: string;
    sessionId!: string;

    constructor(data: ChangeSubscriptionResponseDTO){
        Object.assign(this, data);
    }
}